import React from 'react';
import {Link} from 'react-router-dom';
import _PostDemand from './_PostDemand.scss';

class PostDemand extends React.Component {

  render() {
    return (
      <div className='wrap-btn wrap-btn-post-demand'>
        <Link to='/user/post-demand' className="user-post-demand">
          <i className='vtd-nhu-cau'/>
          <span className='post-demand-text'>Đăng nhu cầu</span>
        </Link>
      </div>
    );
  }
}

export default PostDemand;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/PostDemand.jsx